export default __webpack_public_path__ + "static/media/15.f7fe9dcf.png";